var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 52",
    style: {
      enableBackground: "new 0 0 20 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,18L0,23.5v0.9v10h20v-10v-0.9L10,18z M10,30.9l-8.6-4.8l0.9-1.6l7.7,4.3l7.7-4.3l0.9,1.6L10,30.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,18L0,23.5v0.9v10h20v-10v-0.9L10,18z M10,30.9l-8.6-4.8l0.9-1.6l7.7,4.3l7.7-4.3l0.9,1.6L10,30.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMail);
export default __webpack_public_path__ + "static/media/i_mail.ad4247c2bb2fa8a833fdc650ba879b67.svg";
export { ForwardRef as ReactComponent };